export const ircSlotEnums={
    IRC_DATE:"ircDate",
    DATE_TIME_FORMAT:"DD/MM/YYYY HH:mm",
    COMING_SOON:"Closing Soon!",
    TIME_FORMAT:"HH:mm"
}

export const mettingSlotEnums={
    IRCSlotCardType : "IRCSlotCardType",
}